import {
    Component, Input, Output,
    EventEmitter, OnInit, ViewEncapsulation
} from '@angular/core';
import { CommonHttpService } from '../../../../shared/services/http.service';

@Component({
    selector: 'account-profile-extra-fields-extra-field',
    templateUrl: './account.profile.extra-fields.extra-field.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileExtraFieldsExtraFieldComponent implements OnInit {
    @Input() formExtraFieldValue: string|any;
    @Input() formExtraFieldKey: string;
    @Input() updating = false;
    @Output() updated: EventEmitter<{ key: string, value: any }> = new EventEmitter<{ key: string, value: any }>();

    public value;
    public extraField = null;
    public possibleOptions = [];

    constructor(private http: CommonHttpService) {
    }

    ngOnInit() {
        this.value = this.parseDefaultValue();

        const extraFieldParts = this.formExtraFieldKey.split("_");
        const extraFieldId = extraFieldParts[extraFieldParts.length-1];
        this.http.get(`/ecommerce/extra-fields/${extraFieldId}`)
            .subscribe((response) => {
                this.extraField = response.json().data;
                this.extractPossibleOptions(this.extraField);
            });
    }

    public isStringValue(value) {
        return typeof value === 'string';
    }
    public isSingleOption(value) {
        return typeof value === 'object'
            && false === Array.isArray(value)
            && typeof value.id !== 'undefined';
    }
    public isMultipleOptions(value) {
        return typeof value === 'object'
            && true === Array.isArray(value)
            && true === this.isSingleOption(value[0] || {});
    }
    public changed() {
        this.updated.emit({ key: this.buildChangedKey(), value: this.value});
    }

    private extractPossibleOptions(extraField) {
        this.possibleOptions = extraField.options || [];
    }
    private parseDefaultValue() {
        if (this.isStringValue(this.formExtraFieldValue)) {
            return this.formExtraFieldValue;
        }
        if (this.isSingleOption(this.formExtraFieldValue)) {
            return this.formExtraFieldValue.id;
        }
        if (this.isMultipleOptions(this.formExtraFieldValue)) {
            return this.formExtraFieldValue.map(value => value.id);
        }
    }
    private buildChangedKey() {
        if (this.isStringValue(this.formExtraFieldValue)) {
            return this.formExtraFieldKey;
        }
        if (
            this.isSingleOption(this.formExtraFieldValue)
            || this.isMultipleOptions(this.formExtraFieldValue)
        ) {
            return `${this.formExtraFieldKey}_id`;
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/account/profile/extra-fields/extra-field/account.profile.extra-fields.extra-field.component.ts